'use strict';
var populationElements = document.querySelectorAll('.population');
var total = 0;
populationElements.forEach(function(el) {
    var rawText = el.textContent.replaceAll(',', '').trim();
    var population = Number(rawText);
    if (!isNaN(population)) total += population;
});
var count = populationElements.length;
var average = count > 0 ? Math.round(total / count) : 0;
var totalElement = document.querySelector('.total-population');
var averageElement = document.querySelector('.average-population');
if (totalElement) totalElement.textContent = total.toLocaleString('en-US');
if (averageElement) averageElement.textContent = average.toLocaleString('en-US');

//# sourceMappingURL=js_get_data_DOM.b0e7a444.js.map
